module.exports = __webpack_public_path__ + "img/delete.03972f01.svg";